import { Card, CardMedia, Box, Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';
import { MtComStyleObj } from '../styles/MtComStyleObj';
import { useGetModules } from "../api/vegApl"
import { useCommonStyles } from '../styles/GenericStyle';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../contexts/SnackbarContext';
import { MessageConstant } from '../utils/MessageConst';
import useGetCurrentUser from '../api/useGetCurrentUser';
import { useGlobalState } from '../contexts/GlobalState';
import { GenericConstant } from '../utils/GenericConstant';
export default function ImageText() {
   const classes = useCommonStyles();
   const navigate = useNavigate();
   const { showSnackbar } = useSnackbar();
   const { state: globalState } = useGlobalState();
   const { data: user } = useGetCurrentUser(globalState?.userId || '');

    const { data: modules } = useGetModules({
        query: {
            queryKey: ["modules"],
            select: (d) => d.data,
            refetchOnWindowFocus: false,
            cacheTime: 0,
        },
    });

    const navigarionRoute=(menu:any)=>{
        if (menu?.module_name === "Pre-season Planning") {
            showSnackbar({
                message: "Page not ready. Under development.",
                severity: "info",
                duration: 5000
            });
            return;
        }
        // Restrict all modules if user has no roles
        const userModules = user?.userRoles || [];
        if (!userModules.length) {
            showSnackbar({
                message: MessageConstant.NOPERMISSION,
                severity: "error",
                duration: 5000
            });
            return;
        }
        // Restrict only Pre-season Planning and In-season Operations for non-breeder/admin roles
        const isBreederOrAdmin = userModules.some((role: string) => role && (role.toLowerCase() === 'breeder' || role.toLowerCase() === 'admin'));
        if ((menu?.module_name === "Pre-season Planning" || menu?.module_name === "In-season Operations") && !isBreederOrAdmin) {
            showSnackbar({
                message: MessageConstant.NOPERMISSION,
                severity: "error",
                duration: 5000
            });
            return;
        }
        if (menu?.module_name=="Post-season Processing") {
            navigate("splot");
        }
        else if (menu?.module_name=="In-season Operations") {
            navigate("harvest-req");
        }

    }
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 10,
                p: 2,
                flexWrap: 'wrap',
                marginTop: "64px",
                cursor: "pointer",
                justifyContent: 'center'

            }}
        >
            {modules?.map((menu, index) => {

                if (menu?.module_name == "Global") return null;

                const isPreSeason = menu?.module_name == "Pre-season Planning";
                const noInSeasonAccess = menu?.module_name == "In-season Operations" && !["Breeder", "Admin"].includes(globalState.roleSelected);
                const cardTooltip = isPreSeason
                    ? "Page not ready. Under development."
                    : noInSeasonAccess ? "You don't have permission for visit this page" : "";

                return (<Tooltip key={menu?.module_id} title={cardTooltip} arrow placement="top">
                    {/* .inactive-card sets pointer-events:none, so the wrapper is what the tooltip listens on. */}
                    <Box component="span" sx={{ display: 'inline-flex' }}>
                    <Card
                    className={isPreSeason || noInSeasonAccess ? 'inactive-card' : 'active-card'}
                    sx={{
                        position: 'relative',                      
                        overflow: 'hidden',
                        borderRadius: 3,
                        
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: '60%',
                            background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0) 100%)',
                            pointerEvents: 'none',
                            zIndex: 1
                        },
                        [`&:hover .imgText${index + 1}`]: {
                            transform: 'translateY(-200px)',
                        },
                        [`&:hover .img${index + 1}Des`]: {
                            opacity: 1,
                            transform: 'translateY(0px)',
                            height:20
                        },

                        [`&:hover .img${index + 1}`]: {
                            filter: 'blur(4px) brightness(0.55)',
                           
                        },
                        [`&:hover .arrow${index + 1}`]: {
                            opacity: 1,
                        }
                    }}  onClick={() => navigarionRoute(menu)} >
                    <CardMedia
                        component="img"
                        image={"images/" + menu?.module_name + ".jpg"}
                        className={`img${index + 1}`}
                        classes={{ root: classes.landingPageCardMedia }}
                    ></CardMedia>
                    <Box
                        sx={(theme) => ({
                            position: 'absolute', bottom: '1.5rem', left: '2.5rem', color: theme.palette.common.white,
                            zIndex: 2,

                        })}
                        className={`imgText${index + 1}`}
                    >
                       
                        <Typography component="span" className={classes.moduleName} sx={{fontFamily: GenericConstant.FONTNOTOSONS, fontWeight: 700, fontSize:'48px', lineHeight: 1.2 }}>
                            {menu?.module_name}
                        </Typography>
                        <Typography variant="body2" className={`img${index + 1}Des`} sx={{ mt: 2, opacity: 0, fontFamily: GenericConstant.FONTNOTOSONS, fontWeight: 300, fontSize:'28px',height:0 }}>
                            {menu?.module_desc}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            color: 'white',
                            right: 0,
                            cursor: 'pointer',
                            zIndex: 2
                        }}
                    >
                        <EastOutlinedIcon className={`arrow${index + 1}`} sx={(theme) => ({ ...MtComStyleObj(theme).landingPageArrow, mr:0, mb:1.5, width: 100, height: 32 })}  />

                    </Box>
                </Card>
                    </Box>
                </Tooltip>
                );
            })}
        </Box>

    );
}

